export const convertLineBreak = (sentence: string) => {
    const splitSentence = sentence.split(/<br\s*\/?>/gi);
    return splitSentence.map((item, key) => (
        <div style={{ paddingBottom: "0.25rem" }} key={key}>
            {item}
        </div>
    ));
};
